 <template>
  <div class="pt-5 mt-5 widthFull somatoline" id="firstElem">
    <div class="container-fluid mt-5">
      <div class="form-row justify-content-center">
        <div class="col-lg-4 mb-1 text-center"></div>
      </div>
      <div class="row center mt-5">
        <h2 class="sans-serifBold center pb-4 widthFull"><b>LOGIN</b></h2>
      </div>
    </div>
    <div v-if="codeBeforeLog" class="container">
      <div class="row justify-content-center">
        <div class="col-lg-6 mb-3">
          <form @submit.prevent="goForward">
            <div class="group">
              <input
                type="text"
                v-model="codeLog"
                v-validate="{
                  required: true,
                  max: 56,
                }"
                class="form-control"
                id="codeLog"
                name="codeLog"
                data-vv-as="Codice"
                :class="{
                  'is-invalid': errors.has('codeLog'),
                  valid: !!codeLog,
                }"
              />
              <span class="highlight"></span>
              <span class="bar"></span>
              <label class="niceInputLabel" for="codeLog">Codice utente</label>
              <div v-if="errors.has('codeLog')" class="invalid-feedback">
                {{ errors.first("codeLog") }}
              </div>
            </div>
            <div class="col-md-12 center">
              <button class="btn btn-primary">Procedi</button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div v-if="openlog" class="container">
      <loading v-if="loadingState" />
      <form class="login" id="login-form" @submit.prevent="login">
        <div v-if="confirmed">
          <div v-if="hasEmail" class="form-row justify-content-center">
            <div class="col-lg-6 mb-3">
              <div class="group">
                <input
                  type="text"
                  v-model="username"
                  v-validate="{
                    required: true,
                    email: true,
                    temporaryEmail: true,
                    plusIssueEmail: true,
                    max: 56,
                  }"
                  class="form-control"
                  id="username"
                  name="username"
                  data-vv-as="username"
                  :class="{
                    'is-invalid': errors.has('username'),
                    valid: !!username,
                  }"
                />
                <span class="highlight"></span>
                <span class="bar"></span>
                <label class="niceInputLabel" for="username">Username</label>
                <div v-if="errors.has('username')" class="invalid-feedback">
                  {{ errors.first("username") }}
                </div>
                <div v-if="socialEmail" class="text-danger mt-3">
                  Sei registrato con:
                  <strong class="text-capitalize">{{ socialEmail }}</strong
                  >. Per effetuare accesso clicca sulla apposita icona
                </div>
              </div>
            </div>
          </div>
          <div v-else class="form-row justify-content-center">
            <div class="col-lg-6 mb-3">
              <div class="group">
                <input
                  type="text"
                  autocomplete="username"
                  v-model="username"
                  v-validate="{
                    required: true,
                    max: 56,
                  }"
                  class="form-control"
                  id="username"
                  name="username"
                  data-vv-as="username"
                  :class="{
                    'is-invalid': errors.has('username'),
                    valid: !!username,
                  }"
                />
                <span class="highlight"></span>
                <span class="bar"></span>
                <label class="niceInputLabel" for="username">Username</label>
                <div v-if="errors.has('username')" class="invalid-feedback">
                  {{ errors.first("username") }}
                </div>
              </div>
            </div>
          </div>
          <div class="form-row justify-content-center">
            <div class="col-lg-6 mb-3">
              <div class="group">
                <input
                  type="password"
                  autocomplete="current-password"
                  v-model="password"
                  v-validate="{ required: true, min: 6, max: 56 }"
                  class="form-control"
                  id="password"
                  name="password"
                  data-vv-as="Password"
                  :class="{
                    'is-invalid': errors.has('password'),
                    valid: !!password,
                  }"
                />
                <span class="highlight"></span>
                <span class="bar"></span>
                <label class="niceInputLabel" for="password">Password</label>

                <div v-if="errors.has('password')" class="invalid-feedback">
                  {{ errors.first("password") }}
                </div>
                <div v-if="loginerror" class="mb-3">
                  <span class="formError ml-1">Email o password errati.</span>
                </div>
              </div>
            </div>
          </div>
          <div v-if="hasEmail" class="form-row justify-content-center">
            <div class="col-lg-6 mb-3">
              <router-link
                class="text-red underline sans-serifBold pl-2 mt-3"
                to="/forgot-password"
                >Password dimenticata?</router-link
              >
            </div>
          </div>
          <div class="form-row justify-content-center">
            <div class="col-md-6 mb-3 mt-3 text-center">
              <button class="btn btn-primary" type="submit">ACCEDI</button>
            </div>
          </div>
        </div>
        <div v-else-if="resend_success">
          <div class="form-row justify-content-center">
            <div class="col-md-6 mb-3">
              <h4 class="mb-4 center text-red sans-serifBold">
                <strong
                  >L'e-mail di conferma della registrazione è stata inviata alla
                  tua casella di posta elettronica</strong
                >
              </h4>
            </div>
            <div class="col-md-12 mb-3 center">
              <router-link
                class="btn btn-primary"
                to="/login"
                @click.native="resetState"
                >Accedi</router-link
              >
            </div>
          </div>
        </div>
        <div v-else-if="!resend_success && !confirmed && hasEmail">
				<div class="form-row justify-content-center">
					<div class="col-md-6 mb-3">
						<h4 class="mb-4 center text-red sans-serifBold"><strong>Non hai ricevuto l'e-mail <br/>di conferma della registrazione?</strong></h4>
						<p class="mb-4 mt-5">Controlla che il tuo gestore di posta elettronica non abbia inserito il messaggio nella cartella di posta indesiderata (spam) o con destinatario sconosciuto.</p>
						<p class="mb-4">Se sono passati diversi minuti da quando hai fatto la richiesta e il messaggio non è ancora arrivato clicca sul bottone qui sotto per chiederne il reinivio.</p>
					</div>
					<div class="col-md-8 mb-3 center">
						<button class="btn btn-primary mt-3" v-on:click.prevent="resendConfirmEmail">Invia</button>
					</div>
				</div>
			</div>
      </form>
      <form v-if="!resend_success && !confirmed && !hasEmail" class="form-row justify-content-center">
                <div class="col-md-8">
                <h1 class="h3 darkBlue Bold center pb-3 ">
                    <b>PRIMA DI PROCEDERE AL LOGIN </br>CAMBIA LA TUA PASSWORD</b>
                  </h1>
                  <div class="group" :key="10">
                    <input
                      type="password"
                      v-model="password_CM"
                      autocomplete="on"
                      class="form-control"
                      id="password_CM"
                      name="password_CM"
                      v-validate="{ passwordCheck: true, min: 8, max: 56 }"
                      :class="{
                        'is-invalid': errors.has('password'),
                        valid: !!password_CM,
                      }"
                    />
                    <span class="highlight"></span>
                    <span class="bar"></span>
                    <label class="niceInputLabel label" for="password_CM"
                      >Nuova Password</label
                    >
                    <div v-if="errors.has('password_CM')" class="invalid-feedback">
                      {{ errors.first("password_CM") }}
                    </div>
                  </div>
                  <div class="group" :key="11">
                    <input
                      type="password"
                      v-model="confirm_password_CM"
                      autocomplete="on"
                      class="form-control"
                      id="confirm_password_CM"
                      name="confirm_password_CM"
                      data-vv-as="conferma password"
                      v-validate="{
                        required: !!password_CM,
                        confirmed: password_CM,
                        passwordCheck: true,
                        min: 8,
                        max: 56,
                      }"
                      :class="{
                        'is-invalid': errors.has('confirm_password_CM'),
                        valid: !!confirm_password_CM,
                      }"
                    />
                    <span class="highlight"></span>
                    <span class="bar"></span>
                    <label class="niceInputLabel label" for="password"
                      >Conferma Nuova Password</label
                    >
                    <div
                      v-if="errors.has('confirm_password_CM')"
                      class="invalid-feedback"
                    >
                      {{ errors.first("confirm_password_CM") }}
                    </div>
                  </div>
                  <div class="center mt-5 mt-md-3 mb-md-0 mb-5 pb-5">
                    <button
                    v-on:click="ConfirmPwd()"
                      class="btn btn-primary"
                      tag="button"
                      type="button"
                    >
                      CONFERMA
                    </button>
                  </div>
                </div>
          </form>
    </div>
  </div>
</template>

<script>
import { AUTH_REQUEST, AUTH_SOCIAL } from "actions/auth";
import { mapGetters, mapState } from "vuex";
import axios from "axios";
import Parallax from "vue-parallaxy";

export default {
  name: "login",
  components: {
    Parallax,
  },
  data() {
    return {
      username: "",
      password: "",
      token: "",
      loading: false,
      tempMail: "",
      socialEmail: false,
      social: "",
      confirmed: true,
      resend_success: false,
      codeLog: "",
      confirm_password_CM: "",
      password_CM: "",
      passwordFieldType: "password",
      codeBeforeLog: process.env.CODE_BEFORE_LOG,
      hasEmail: process.env.LOGIN_WITH_EMAIL,
      openlog: false,
    };
  },
  methods: {
    switchVisibility() {
      this.passwordFieldType =
        this.passwordFieldType === "password" ? "text" : "password";
    },
    showAlert() {
      // Use sweetalret2
      this.$swal({
        type: "error",
        title: "Oops...",
        text: "Something went wrong!",
      });
    },
    login: function () {
      const { username, password } = this;

      this.$validator.validate().then((valid) => {
        if (valid) {
          var data = {
            username: username,
            password: password,
            id_platform: process.env.ID_PLATFORM,
            unique_key_db: process.env.UNIQUE_KEY_DB,
            vector_unique_key_db: process.env.ICODE,
          };
          data = this.$encryptByAES(JSON.stringify(data), process.env.CRYPTKEY);
          this.$store.dispatch(AUTH_REQUEST, { data }).then((resp) => {
            this.$track({ resp });

            this.$track(this.$router);

            this.$router.push("/account");
            if (
              process.env.GTAGEVENT == "on" &&
              process.env.GTAGAWSTATUS == "on" &&
              process.env.GTAGEVENT == "off"
            ) {
              this.$track("Gtag", this.$gtag);
              this.$gtag.reportConversion({
                send_to: process.env.SENDTO, // the custom tag to be reported
                action: "login",
                status: "success",
                clients: username,
              });
            } else if (
              process.env.GTAGEVENT == "on" &&
              process.env.GTAGSTATUS == "on" &&
              process.env.GTAGAWSTATUS == "off"
            ) {
              this.$gtag.event("send", {
                event_category: "success",
                event_label: "login",
                value: username,
              });

              this.$track("Gtag", this.$gtag);
            }
          });
        }
      });
    },

    resetState: function () {
      this.resend_success = false;
      this.confirmed = true;
    },
    ConfirmPwd: function () {
      this.$validator.validate().then((valid) => {
        if (valid && this.password_CM && this.username) {
          this.loadingState = true;
          var _vue = this;
          var data = {
            password: this.password_CM,
            username: this.username,
            id_platform: process.env.ID_PLATFORM,
            unique_key_db: process.env.UNIQUE_KEY_DB,
            vector_unique_key_db: process.env.ICODE,
          };
          this.$callLog("ConfirmPwd", data);
          data = this.$encryptByAES(JSON.stringify(data), process.env.CRYPTKEY);
          axios({
            url: process.env.ROOT_API + "api/ConfirmPwd",
            method: "POST",
            headers: {
              Authorization: "Bearer " + process.env.AUTH_TOKEN,
              "Content-type": "application/json",
            },
            data: { data },
          })
            .then((resp) => {
              resp.data = this.$decryptByAES(resp.data, process.env.CRYPTKEY);
              this.$track("ConfirmPwd", "SUECCESS");
              this.showAlertSuccess(
                    "Hai aggiornato correttamente la password, ritorna alla schermata di login per accedere alla piattaforma"
                  );
              //this.resend_success = false;
              //this.confirmed = true;
              //_vue.loadingState = false;
            })
            .catch((resp) => {
              resp.response.data = this.$decryptByAES(
                resp.response.data,
                process.env.CRYPTKEY
              );
              this.$track("ConfirmPwd", "ERROR");
              _vue.loadingState = false;
              _vue.showError(resp.response.data.description);
            });
        } else {
        }
      });
    },
    showAlertSuccess(value) {
      // Use sweetalret2
      this.$swal({
        type: "success",
        html: value,
        showCancelButton: false,
        animation: false,
        onClose: () => {
          this.$router.push("/");
        },
      });
    },
    goForward: function () {
      this.$validator.validate().then((valid) => {
        if (valid) {
          this.loadingState = true;
          var _vue = this;
          var data = {
            code: this.codeLog,
            id_platform: process.env.ID_PLATFORM,
            unique_key_db: process.env.UNIQUE_KEY_DB,
            vector_unique_key_db: process.env.ICODE,
          };
          this.$callLog("goForward", data);
          data = this.$encryptByAES(JSON.stringify(data), process.env.CRYPTKEY);
          axios({
            url: process.env.ROOT_API + "api/goForward",
            method: "POST",
            headers: {
              Authorization: "Bearer " + process.env.AUTH_TOKEN,
              "Content-type": "application/json",
            },
            data: { data },
          })
            .then((resp) => {
              resp.data = this.$decryptByAES(resp.data, process.env.CRYPTKEY);
              this.$track("goForward", "SUECCESS");
              _vue.loadingState = false;
            })
            .catch((resp) => {
              resp.response.data = this.$decryptByAES(
                resp.response.data,
                process.env.CRYPTKEY
              );
              this.$track("goForward", "ERROR");
              _vue.loadingState = false;
              _vue.showError(resp.response.data.description);
            });
        } else {
        }
      });
    },

    checkIfExistEmail: function (value) {
      const newValue = value.target.value;

      const field = this.$validator.fields.find({ name: "email" });

      if (!this.errors.has("email") && this.tempMail != newValue) {
        this.tempMail = newValue;
        var data = {
          param: newValue,
          table: "utenti",
          fieldName: "email",
          fieldIdPlatform: "idPlatform_utenti",
          id_platform: process.env.ID_PLATFORM,
          unique_key_db: process.env.UNIQUE_KEY_DB,
          vector_unique_key_db: process.env.ICODE,
        };
        this.$callLog("checkIfExistEmail", data);
        data = this.$encryptByAES(JSON.stringify(data), process.env.CRYPTKEY);
        axios({
          method: "POST",
          data: { data },
          url: process.env.ROOT_API + "api/checkIfIsUnique",
          headers: {
            Authorization: "Bearer " + process.env.AUTH_TOKEN,
            "Content-type": "application/json",
          },
        })
          .then((resp) => {
            this.socialEmail = false;
            this.$respLog("checkIfExistEmail", resp);
          })
          .catch((error) => {
            this.$respLog("checkIfExistEmail", error.response);
            if (error.response.data.message != "manual") {
              this.socialEmail = error.response.data.message;
            }
          });
      }
    },
    checkIfExistCod: function (value) {
      const newValue = value.target.value;

      const field = this.$validator.fields.find({ name: "email" });

      if (!this.errors.has("email") && this.tempMail != newValue) {
        this.tempMail = newValue;
        var data = {
          param: newValue,
          table: "utenti",
          fieldName: "cod",
          fieldIdPlatform: "idPlatform_utenti",
          id_platform: process.env.ID_PLATFORM,
          unique_key_db: process.env.UNIQUE_KEY_DB,
          vector_unique_key_db: process.env.ICODE,
        };
        this.$callLog("checkIfExistCod", data);
        data = this.$encryptByAES(JSON.stringify(data), process.env.CRYPTKEY);
        axios({
          method: "POST",
          data: { data },
          url: process.env.ROOT_API + "api/checkIfIsUnique",
          headers: {
            Authorization: "Bearer " + process.env.AUTH_TOKEN,
            "Content-type": "application/json",
          },
        })
          .then((resp) => {
            this.socialEmail = false;
            this.$respLog("checkIfExistCod", resp);
          })
          .catch((error) => {
            this.$respLog("checkIfExistCod", error.response);
            if (error.response.data.message != "manual") {
              this.socialEmail = error.response.data.message;
            }
          });
      }
    },
  },
  computed: {
    ...mapGetters([
      "loginerror",
      "loadingState",
      "isAuthenticated",
      "isProfileLoaded",
      "authStatus",
    ]),
    ...mapState({
      profile: (state) => state.user.profile,
    }),
  },
  watch: {
    authStatus(value) {
      if (value == "not_confirmed") {
        this.confirmed = false;
      }
    },
  },
  mounted: function () {
    window.onresize = () => {
      this.vw = window.innerWidth;
      this.vh = window.innerHeight;
    };
    if (!this.codeBeforeLog) this.openlog = true;
    var _vue = this;
    setTimeout(function () {
      _vue.$scrollTo("#firstElem", 0, { offset: -125 });
    }, 100);
  },
  created() {},
};
</script>



// WEBPACK FOOTER //
// src/components/login/index.vue